import { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { KeysFormKey } from '../MessageForms.types';

import { KeysLostForm } from './KeysLostForm';
import { KeysRequestForm } from './KeysRequestForm';

export const keysForms: Record<KeysFormKey, FC<ParsedEntry<IWidget>>> = {
  [KeysFormKey.KEYS_LOST]: KeysLostForm,
  [KeysFormKey.KEYS_REQUEST]: KeysRequestForm,
};
